<template>
  <div class="details">
     <div class="section">
        <div class="title">
          {{ $t('product.productDesc') }}
        </div>
        <div class="content">
          {{ productInfo.description }}
        </div>
     </div>
     <div class="section">
        <div class="title">
          {{ $t('product.productDisplay') }}
        </div>
        <div class="swiper-box">
          <swiper :options="swiperOptions">
            <swiper-slide v-for="item in (productInfo.id === '6' ? 1 : 3)" :key="item">
              <img class="swiper-img" :src="getSwiperImg(productType, productInfo.id, item)" alt="">
            </swiper-slide>
          </swiper>
          <div v-if="productInfo.id !== '6'" class="swiper-control">
            <div class="swiper-pagination"></div>
            <div class="swiper-button">
             
              <div class="prev">
                <img src="@/assets/icons/next.svg" alt="">
              </div>
              <div class="next">
                <img src="@/assets/icons/prev.svg" alt="">
               
              </div>
            </div>
          </div>
        </div>
     </div>
     <div class="section">
        <div class="title">
          {{ $t('product.techSpec') }}
        </div>
        <ul class="spec-list">
          <li>
            <div class="param-name">
              {{ $t('product.dimension') }}
            </div>
            <div class="param-value">
              {{ productInfo.specifications.dimensions }}
            </div>
          </li>
          <li>
            <div class="param-name">
              {{ $t('product.netWeight') }}
            </div>
            <div class="param-value">
             {{ productInfo.specifications.net_weight }}
            </div>
          </li>
          <li>
            <div class="param-name">
              {{ $t('product.grossWeight') }}
            </div>
            <div class="param-value">
              {{ productInfo.specifications.gross_weight }}
            </div>
          </li>
          <li>
            <div class="param-name">
              {{ $t('product.packageDimension') }}
            </div>
            <div class="param-value">
              {{ productInfo.specifications.package_size }}
            </div>
          </li>
          <li>
            <div class="param-name">
              {{ $t('product.material') }}
            </div>
            <div class="param-value">
              {{ productInfo.specifications.materials }}
            </div>
          </li>
        </ul>
     </div>
     <div class="section">
        <div class="title">
          {{ $t('product.applicableScene') }}
        </div>
       <ul class="scene-list">
          <li v-for="item in productInfo.usage_scenarios" :key="item">
            {{ item }}
          </li>
        </ul>
     </div>
     <div class="section">
        <div class="title">
          {{ $t('product.compatibleProduct') }}
        </div>
        <div class="tips">
          {{ productInfo.compatibleProductDesc }}
        </div>
        <ul class="compatible-list">
          <li v-for="item in compatibleList" :key="item">
            <img :src="item" alt="">
          </li>
        </ul>
     </div>
  </div>
</template>

<script>
export default {
  props: {
    productInfo: {
      type: Object,
      default: () => {},
    },
    productType: {
      type: String,
      default: '',
    },
  },
  computed: {
    compatibleList() {
      if (this.productType === '3.0') {
        if(this.productInfo.id === '6'){
          return [
            require('@/assets/images/earphone/swim_pro.webp'),
          ]
        }else {
          return [
          require('@/assets/images/earphone/fit2_series.webp'),
          require('@/assets/images/earphone/dots_one.webp'),
          require('@/assets/images/earphone/fit.webp'),
          require('@/assets/images/earphone/fit_air.webp'),
          require('@/assets/images/earphone/run_pro2.webp'),
          require('@/assets/images/earphone/run_pro.webp'),
          require('@/assets/images/earphone/run_pro_mini.webp'),
          require('@/assets/images/earphone/run.webp'),
          require('@/assets/images/earphone/run_mini.webp'),
          require('@/assets/images/earphone/swim_pro.webp'),
          require('@/assets/images/earphone/swim.webp'),
          require('@/assets/images/earphone/comm2.webp'),
          require('@/assets/images/earphone/comm2_uc.webp'),
          require('@/assets/images/earphone/move.webp'),
          ]
        }
      }else {
        return [
          require('@/assets/images/earphone/fit2_series.webp'),
          require('@/assets/images/earphone/fit_pro.webp'),
          require('@/assets/images/earphone/dots_one.webp'),
          require('@/assets/images/earphone/fit.webp'),
          require('@/assets/images/earphone/fit_air.webp'),
          require('@/assets/images/earphone/run_pro2.webp'),
          require('@/assets/images/earphone/run_pro.webp'),
          require('@/assets/images/earphone/run_pro_mini.webp'),
          require('@/assets/images/earphone/run.webp'),
          require('@/assets/images/earphone/run_mini.webp'),
          require('@/assets/images/earphone/swim_pro.webp'),
          require('@/assets/images/earphone/swim.webp'),
          require('@/assets/images/earphone/comm2.webp'),
          require('@/assets/images/earphone/comm2_uc.webp'),
          require('@/assets/images/earphone/move.webp'),
        ]
      }
    }
  },
  data() {
    return {
      language: 'cn',
      swiperOptions: {
        loop: this.productType === '3.0' ? false : true,
        slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
          nextEl: '.swiper-button .next',
          prevEl: '.swiper-button .prev',
          clickable: true,
        },
        breakpoints: {
          850: {
            slidesPerView: 1,
          },
        },
        pagination: { el: '.swiper-pagination' },
        autoplay:{
          delay: 3000,
          disableOnInteraction: false,
        },
      }
    };
  },
  methods: {
    getSwiperImg(type, id, index) {
      return require(`@/assets/images/procuct/swiper_${type}_${id}_${index}.webp`);
    }
  }
}
</script>

<style lang='scss' scoped>
.details {
  .section {
       .swiper-img {
        width: 100%;
        border-radius: 6px;
       }
       .swiper-control {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
       }
       ::v-deep .swiper-pagination {
          position: static;
          .swiper-pagination-bullet {
            width: 8px;
            height: 8px;
            background: #0A0A0A;
            opacity: 0.3;
            border-radius: 10px;
            margin-right: 16px;
          }
          .swiper-pagination-bullet-active {
            width: 30px;
            height: 8px;
            opacity: 0.75;
          }
       }
       .swiper-button {
        display: flex;
        >div {
          padding: 8px;
          border-radius: 50%;
          background: #E5E7EB;
          margin-left: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        img {
          width: 20px;
        }
       }

       .spec-list {
        width: calc(50% - 12px);
         li {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid #E5E5E5;

         .param-name {
            width: 180px;
            font-size: 16px;
            font-weight: 500;
            line-height: 21px;
            color: #0A0A0A;
         }
         .param-value {
            font-size: 16px;
            font-weight: 400;
            line-height: 21px;
            color: #404040;
         }
        }
      }

      .scene-list {
        display: flex;
        gap: 24px;
        li {
          width: 180px;
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          background: #F3F4F6;
          font-size: 16px;
          line-height: 130%;
          color:#000;
          text-align: center;
          padding: 12px;
        }
      }
      .tips {
        margin-bottom: 16px;
        color: #404040;
        font-size: 16px;
        line-height: 130%;

      }
  }
  
}
@media screen and (max-width: 850px) { 
  .details {
    .section {
      ::v-deep .swiper-pagination {
          .swiper-pagination-bullet {
            width: 6px;
            height: 6px;
            margin-right: 8px;
          }
          .swiper-pagination-bullet-active {
            width: 36px;
            height: 6px;
          }
       }

       .spec-list {
        width: 100%;
         li {
         .param-name {
            width: 94px;
            line-height: 130%;
         }
         .param-value {
            font-size: 14px;
            line-height: 130%;
         }
        }
      }

      .scene-list {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        li {
          width: calc(50% - 8px);
          border-radius: 6px;
        }
      }
    }
  }
}
</style>